import { environment } from '../../../environments/environment';
import { extractEmailDomain } from '../utils';

export function useIsZspaceInternalEmail(email: string) {
  return environment.internalUserEmailDomains
    .split(',')
    .includes(extractEmailDomain(email)!);
}

export default useIsZspaceInternalEmail;
